import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { EvaluationPathType } from "../../../../api/graphql";
import { ShowString } from "../../../common/controls";
import { QueryPatternSource } from "../../../../api/graphql";
import { ShowNumber } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type QueryPatternViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  patternValue?: { displayId: string; id: string } | null;
  pattern: string;
  pathTypeOptions: { id: string; displayId: string }[];
  pathType: EvaluationPathType;
  variablesValue?: { displayId: string; id: string } | null;
  variables: string;
  toolTemplateValue?: { displayId: string; id: string } | null;
  toolTemplate: string;
  argsTemplateValue?: { displayId: string; id: string } | null;
  argsTemplate: string;
  variationsValue?: { displayId: string; id: string } | null;
  variations: string;
  exampleInstantiationValue?: { displayId: string; id: string } | null;
  exampleInstantiation: string;
  sourceOptions: { id: string; displayId: string }[];
  source: QueryPatternSource;
  qualityScoreValue?: { displayId: string; id: string } | null;
  qualityScore: number;
  usageCountValue?: { displayId: string; id: string } | null;
  usageCount: number;
  isActiveValue?: { displayId: string; id: string } | null;
  isActive: boolean;
  notesValue?: { displayId: string; id: string } | null;
  notes: string;
};

export const QueryPatternViewForm: React.FC<QueryPatternViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      name = "",
      pattern = "",
      pathTypeOptions = [],
      pathType = "" as EvaluationPathType,
      variables = "{}",
      toolTemplate = "",
      argsTemplate = "{}",
      variations = "{}",
      exampleInstantiation = "",
      sourceOptions = [],
      source = "" as QueryPatternSource,
      qualityScore = 0,
      usageCount = 0,
      isActive = false,
      notes = "",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupQueryPatternLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={name}
                  label={langStore.QueryPatternNameLabel}
                />
                <ShowMultiLine
                  value={pattern}
                  label={langStore.QueryPatternPatternLabel}
                />
                <ShowString
                  value={
                    pathType
                      ? pathTypeOptions.find(
                          (o: { id: string }) => o.id === pathType
                        )?.displayId || pathType
                      : ""
                  }
                  label={langStore.QueryPatternPathTypeLabel}
                />
                <ShowMultiLine
                  value={variables}
                  label={langStore.QueryPatternVariablesLabel}
                />
                <ShowMultiLine
                  value={toolTemplate}
                  label={langStore.QueryPatternToolTemplateLabel}
                />
                <ShowMultiLine
                  value={argsTemplate}
                  label={langStore.QueryPatternArgsTemplateLabel}
                />
                <ShowMultiLine
                  value={variations}
                  label={langStore.QueryPatternVariationsLabel}
                />
                <ShowMultiLine
                  value={exampleInstantiation}
                  label={langStore.QueryPatternExampleInstantiationLabel}
                />
                <ShowString
                  value={
                    source
                      ? sourceOptions.find(
                          (o: { id: string }) => o.id === source
                        )?.displayId || source
                      : ""
                  }
                  label={langStore.QueryPatternSourceLabel}
                />
                <ShowNumber
                  value={qualityScore}
                  label={langStore.QueryPatternQualityScoreLabel}
                />
                <ShowNumber
                  value={usageCount}
                  label={langStore.QueryPatternUsageCountLabel}
                />
                <ShowBoolean
                  value={isActive}
                  label={langStore.QueryPatternIsActiveLabel}
                />
                <ShowMultiLine
                  value={notes}
                  label={langStore.QueryPatternNotesLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
